mutation updateFont($fontId: ID!, $font: InputFont!) {
    updateFont(fontId: $fontId, font: $font) {
        _id
    }
}
